'use strict';

function CheckBank() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [_BankController];
  this._analytics = new Analytics();
  this.presenter = null;
  this.onStatusOnline = null;
  this.onStatusOffline = null;
  this.onStatusNotSupported = null;
  this.onDltSupported = null;
  this.processUrls = {
    'card-load': '/member/dashboard/card/load/select-bank/check-bank',
    'loan-bank-statement': '/member/dashboard/loans/apply/bank-statement/check-bank'
  };
  this.processSupportedProps = {
    'card-load': 'is_visa_direct_supported',
    'loan-bank-statement': 'is_plaid_supported'
  };
  this._CHECK_BANK_PATH = '/member/account/link-bank-check-bank';

  this.init = function () {
    if (!this.process) return console.error('analytics: process and processUrl needed');
    this._$node = $(this.node);
    this._$preloaderContainer = $('<div>', { class: 'mogo-component-plaid-bank-error--loader' });
    this._$preLoader = $('<span>', { class: 'progress-infinite dark' });
    this._$node.css('display', 'block').html(this._$preloaderContainer.append(this._$preLoader));
    this._$node.load(this._CHECK_BANK_PATH, this._onLoadHTML.bind(this));
  };

  this.initAllReady = function () {
    this.show();
  };

  this.show = function () {
    this.current_selected_bank_id = null;
    if (this.$pickBankSelect && this.$pickBankSelect.mogo && this.$pickBankSelect.mogo().setSelectedIndex) {
      this.$pickBankSelect.mogo().setSelectedIndex(0);
    }

    var virtualUrl = this.processUrls[this.process];
    if (this.process == 'loan-bank-statement') {
      this._analytics.forcePushEvent('virtual-page-view', {
        Page: [window.location.origin + virtualUrl]
      });
    }
  };

  this._onLoadHTML = function () {
    this._setupMessaging();
    this._$preLoader.remove();
    this.presenter.scanDOM();
    this._$node.children().mogo().parse();
    $('[data-mogo-ui=Portal]').mogo().scanNodeForClickAnalytics(this._$node);
    var callbacks = {};
    callbacks.onStatusOnline = this.onStatusOnline.bind(this);
    callbacks.onStatusOffline = this.onStatusOffline.bind(this);
    callbacks.onStatusNotSupported = this.onStatusNotSupported.bind(this);
    if (this.process === 'loan-bank-statement') {
      callbacks.onDltSupported = this.onDltSupported.bind(this);
    }
    this.getBankList(this._setupBankSelector(callbacks));
  };

  this._setupMessaging = function () {
    // Configure the UI elements for different flows:
    // if (this.process === 'account-link' || this.process === 'card-load') {
    //   this.presenter.addComputedVariable('link-process', null, function () { return true; });
    // } else
    if (this.process === 'loan-bank-statement') {
      this.presenter.addComputedVariable('bank-statement-process', null, function () {
        return true;
      });
    }
  };

  this._setupBankSelector = function (callbacks) {
    this.$pickBankSelect = $('.js--banking-institutions');
    this.$pickBankWrapper = $('.js--banking-institutions-container');
    this.$checkBankButton = $('.js--check-bank');

    if (!this._isCheckBankInitialized) {
      this._isCheckBankInitialized = true;
      this._setLoadingBanksListState();
      this._createBanksList(this.presenter.models.banking.banks);

      if (this.process === 'loan-bank-statement') {
        this.$checkBankButton.on('click', this._onCheckBankClick.bind(this, callbacks));
      } else {
        this.$pickBankSelect.on('change', this._onCheckBankClick.bind(this, callbacks));
      }
    } else {
      this.resetSelectorButtonState();
    }
  };

  this.resetSelectorButtonState = function () {
    this.presenter.updateDOM(); // TODO: investigate: doesnt seem needed in this flow
    this.$checkBankButton.mogo().resetState(); // TODO: investigate: doesnt seem needed in this flow
    this.$checkBankButton.mogo().removeDisabledState();
  };

  this._createBanksList = function (data, response) {
    var supportedBanks = [];
    var otherBanks = [];
    var sortedBanks = [];
    var formattedBanks = [];
    var supportedProp = this.processSupportedProps[this.process];

    data.banks.forEach(function (element) {
      if (element[supportedProp]) supportedBanks.push(element);else otherBanks.push(element);
    });

    sortedBanks = otherBanks.sort(function (a, b) {
      return a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1;
    });

    formattedBanks = supportedBanks.concat(sortedBanks);

    for (var i = 0; i < formattedBanks.length; i++) {
      var bank = formattedBanks[i];
      var isLast = i === formattedBanks.length - 1;

      this.$pickBankSelect.mogo().addOption(bank.name, bank.id, false, isLast);
    }
    this._setDoneLoadingBanksListState();
    this.$pickBankSelect.change(this._onBankSelected.bind(this));
  };

  this._onCheckBankClick = function (callbacks, e) {
    if (!this.current_selected_bank_id) {
      this._analytics.forcePushEvent('form-errors', { FormErrors: ['banking-institution'] });
      this.$pickBankSelect.mogo().showErrorLabel(false);
      return;
    }

    if (this.process === 'loan-bank-statement') {
      $(e.currentTarget).mogo().setDisabledLoadState();
      this.bankPlaidStatusCheck(parseInt(this.current_selected_bank_id), callbacks); // _BankController.js
    } else {
      var _bankName = e.currentTarget[e.currentTarget.selectedIndex].text;
      this._analytics.forcePushEvent('generic-member-navigation', {
        memberNavigation: ['MogoCard-Navigation-Dropdown Navigation ' + _bankName + '-Navigation-Component']
      });
      this.bankVisaDirectStatusCheck(parseInt(this.current_selected_bank_id), callbacks); // _BankController.js
    }
  };

  this._onBankSelected = function () {
    this.$pickBankSelect.mogo().hideErrorLabel();
    this.$pickBankSelect.mogo().hideError();
    this.current_selected_bank_id = $(':selected', this.$pickBankSelect).val();
  };

  this._setLoadingBanksListState = function () {
    this.$pickBankSelect.parent().hide();
    this.$checkBankButton.hide();
    this.$pickBankWrapper.append("<span class='progress-infinite dark'></span>");
  };

  this._setDoneLoadingBanksListState = function () {
    this.$pickBankWrapper.find('.progress-infinite').remove();
    this.$checkBankButton.show();
    this.$pickBankSelect.parent().show();
    this.$pickBankSelect.mogo().setDisabled(false);
  };

  this.destroy = function () {
    // if (this.process === 'account-link' || this.process === 'card-load') {
    //   this.presenter.removeComputedVariable('link-process');
    // } else

    if (this.process === 'loan-bank-statement') {
      this.presenter.removeComputedVariable('bank-statement-process');
    }
  };
}